import { MultiUseCardsContainer } from 'modules/multi-use-cards';

import { ErrorBoundary } from '../../common/components/withErrorBoundary';

export const MultiUseCardsPage = () => {
  return (
    <div className="page__container">
      <ErrorBoundary
        context={{
          team: 'banking-gateway',
          scope: 'multi-use-cards',
        }}
      >
        <MultiUseCardsContainer />
      </ErrorBoundary>
    </div>
  );
};
